import styled from "styled-components";
import {fontFamilies, radii} from "theme/tokens";

/**
 * The coupon band across the top of the pricing sheet (ui#2441): red paper with white print and a
 * perforated lower edge, the language {@link ../peel/PeelTicket.styles} prints the welcome coupon in.
 * The mask bites a row of half-circles out of the bottom edge so the sheet shows through the tear.
 */
export const Band = styled.div`
	position: relative;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 6px 20px;
	padding: 13px 22px 18px;
	background: ${({theme}) => theme.tokens.ticketRed};
	color: ${({theme}) => theme.tokens.ticketPaper};
	mask: radial-gradient(circle at 50% 100%, transparent 3.5px, ${({theme}) => theme.tokens.ticketInk} 4px) 0 0 / 12px 100% repeat-x;

	@media (max-width: 640px) {
		padding: 12px 18px 17px;
	}
`;

export const Eyebrow = styled.p`
	margin: 0;
	font-family: ${fontFamilies.mono};
	font-size: 12px;
	font-weight: 800;
	line-height: 1.4;
	letter-spacing: 0.06em;
	text-transform: uppercase;
`;

export const Meta = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 6px 14px;
	font-family: ${fontFamilies.mono};
	font-size: 10px;
	font-weight: 700;
	line-height: 1.5;
	letter-spacing: 0.03em;
	text-transform: uppercase;
`;

export const Sentence = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 8px;
`;

/** A dashed cut between the counter and the deadline; hidden where the band wraps to two lines. */
export const Rule = styled.span`
	width: 0;
	align-self: stretch;
	border-left: 1.5px dashed ${({theme}) => theme.tokens.ticketLine};

	@media (max-width: 640px) {
		display: none;
	}
`;

/** The day and time the run ends, in the reader's own zone; a `<time>` so the instant is machine-readable. */
export const Until = styled.time`
	font-variant-numeric: tabular-nums;
`;

/** The live countdown to that instant. */
export const Deadline = styled.span`
	font-variant-numeric: tabular-nums;
`;

export const Meter = styled.span`
	display: inline-flex;
	gap: 4px;
	flex: none;

	@media (max-width: 640px) {
		display: none;
	}
`;

/** One filled pill dot per welcome price still left, on ticket-line white. */
export const Dot = styled.i`
	display: block;
	width: 7px;
	height: 7px;
	border-radius: ${radii.pill};
	background: ${({theme}) => theme.tokens.ticketPaper};
`;

/** The one neutral line at zero left, in the band's place at the top of the sheet. */
export const Neutral = styled.p`
	margin: 0;
	padding: 13px 22px;
	border-bottom: 1px solid ${({theme}) => theme.tokens.line};
	text-align: center;
	font-size: 12px;
	line-height: 1.4;
	color: ${({theme}) => theme.tokens.ink2};
`;
